(() => {
  const drawer = document.querySelector('[data-cart-drawer]');
  if (!drawer) return;

  const panel = drawer.querySelector('.correnva-cart-drawer__panel');
  const itemsNode = drawer.querySelector('[data-cart-drawer-items]');
  const footer = drawer.querySelector('[data-cart-drawer-footer]');
  const subtotal = drawer.querySelector('[data-cart-subtotal]');
  let returnFocus = null;

  const money = (cents, currency) => {
    try { return new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency }).format(cents / 100); }
    catch (_) { return `$${(cents / 100).toFixed(2)}`; }
  };
  const escapeHTML = (value = '') => String(value).replace(/[&<>'"]/g, (character) => ({ '&':'&amp;', '<':'&lt;', '>':'&gt;', "'":'&#039;', '"':'&quot;' }[character]));

  const open = (trigger) => {
    returnFocus = trigger || document.activeElement;
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('correnva-cart-open');
    requestAnimationFrame(() => panel.focus({ preventScroll: true }));
  };
  const close = () => {
    drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('correnva-cart-open');
    if (returnFocus && typeof returnFocus.focus === 'function') returnFocus.focus({ preventScroll: true });
  };

  const render = (cart) => {
    document.querySelectorAll('[data-cart-count]').forEach((node) => { node.textContent = cart.item_count; });
    subtotal.textContent = money(cart.total_price, cart.currency);
    footer.hidden = cart.item_count === 0;
    if (!cart.item_count) {
      itemsNode.innerHTML = '<div class="correnva-cart-drawer__empty"><strong>Your bag is clear.</strong><p>Choose a verified piece and it will appear here.</p></div>';
      return;
    }
    itemsNode.innerHTML = cart.items.map((item) => {
      const image = item.image ? `<img src="${escapeHTML(item.image)}&width=240" width="92" height="92" alt="${escapeHTML(item.product_title)}">` : '';
      const variant = item.variant_title && item.variant_title !== 'Default Title' ? `<small>${escapeHTML(item.variant_title)}</small>` : '';
      return `<article class="correnva-cart-drawer__item" data-cart-line-key="${escapeHTML(item.key)}">${image}<div><a href="${escapeHTML(item.url)}">${escapeHTML(item.product_title)}</a>${variant}<span>${money(item.final_line_price, cart.currency)}</span><div class="correnva-cart-drawer__quantity" aria-label="Quantity"><button type="button" data-cart-quantity="${Math.max(0,item.quantity - 1)}" aria-label="Decrease quantity">−</button><span>${item.quantity}</span><button type="button" data-cart-quantity="${item.quantity + 1}" aria-label="Increase quantity">+</button></div></div></article>`;
    }).join('');
  };

  const refresh = async () => {
    const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`, { headers: { Accept: 'application/json' } });
    if (!response.ok) throw new Error('Cart refresh failed');
    const cart = await response.json();
    render(cart);
    return cart;
  };

  document.addEventListener('click', async (event) => {
    const closeButton = event.target.closest('[data-cart-close]');
    if (closeButton) { event.preventDefault(); close(); return; }

    const cartLink = event.target.closest('[data-cart-toggle], a[href$="/cart"], a[href$="/cart/"]');
    if (cartLink && !cartLink.hasAttribute('data-cart-page') && !event.metaKey && !event.ctrlKey && !event.shiftKey && event.button === 0) {
      event.preventDefault();
      try { await refresh(); } catch (_) { /* Keep server-rendered cart as fallback. */ }
      open(cartLink);
      return;
    }

    const quantityButton = event.target.closest('[data-cart-quantity]');
    if (!quantityButton) return;
    const item = quantityButton.closest('[data-cart-line-key]');
    if (!item) return;
    quantityButton.disabled = true;
    try {
      const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/change.js`, { method: 'POST', headers: { 'Content-Type':'application/json', Accept:'application/json' }, body: JSON.stringify({ id: item.dataset.cartLineKey, quantity: Number(quantityButton.dataset.cartQuantity) }) });
      if (!response.ok) throw new Error('Cart update failed');
      render(await response.json());
    } catch (_) { window.location.assign('/cart'); }
  });

  document.addEventListener('submit', async (event) => {
    const form = event.target.closest('[data-product-form]');
    if (!form || event.submitter?.name === 'checkout') return;
    event.preventDefault();
    const button = form.querySelector('[name="add"]');
    if (button?.disabled) return;
    if (button) button.setAttribute('aria-busy', 'true');
    try {
      const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, { method: 'POST', headers: { Accept:'application/json' }, body: new FormData(form) });
      if (!response.ok) throw new Error('Add to cart failed');
      await refresh();
      open(button);
    } catch (_) {
      form.removeAttribute('data-product-form');
      form.submit();
    } finally { if (button) button.removeAttribute('aria-busy'); }
  });

  document.addEventListener('keydown', (event) => { if (event.key === 'Escape' && drawer.getAttribute('aria-hidden') === 'false') close(); });
})();
